import React, { useEffect, useState } from "react";
import {Table, Row, Col, Card, CardBody, Modal, CardTitle, ModalHeader, ModalBody, FormGroup, Label, InputGroup, Button} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import moment from "moment";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { PhoneInput } from 'react-international-phone';
import { json, Link } from "react-router-dom";
const Tranches = () => {
  document.title = "AMAVIE | Gestion de la tarification";
  const removeBodyCss = () => { document.body.classList.add("no_padding"); };
  const [tranches, setTranches]= useState([])
  const loadTranche=()=> {
      fetch(`${url.BACKEND_URL}/tranches`, {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => { 
        if (responseJson.status==200) { setTranches(responseJson.data) }
      }) .catch((error) => {  });
    };
  useEffect(()=>{ loadTranche() }, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="AMAVIE" title="Tranches" />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <div className="table-responsive">
                    <Table className="table mb-0" style={{fontSize: 16}}>
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Tranche</th>
                          <th>Modifier</th>
                          {/* <th>Détails</th> */}
                        </tr>
                      </thead>
                      <tbody>
                         {tranches.map((item, key)=>(
                            <tr>
                              <td><span className="badge bg-success" style={{padding: 7}}>{item?.id}</span></td>
                              <td>
                                <span className="badge bg-warning" style={{padding: 7}}>
                                  De {item?.min} ans à {item?.max} ans
                                </span>
                              </td>
                              <td>Modifier</td>
                              {/* <td><a className="fas fa-book" onClick={()=>{setTimeout(() => { tog_detail_tarification(item)}, 400);}}></a></td> */}
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Tranches;
